// lib/api.js

import { API_BASE_URL } from "./constans";

const API_URL = API_BASE_URL;
const FETCH_TIMEOUT = 10000; // 10 segundos
const CACHE_TIME = 60; // 60 segundos

// Función genérica reutilizable
async function fetchAPI(endpoint) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      signal: controller.signal,
      next: { revalidate: CACHE_TIME },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} - ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error.message);
    return null; // o throw según necesites
  } finally {
    clearTimeout(timeoutId);
  }
}


//resources
export const getYachtsData = () => fetchAPI('/page/resources/yachts');
export const getYachtData = (id) => fetchAPI(`/page/resources/yachts/${id}`);
